module.exports = __webpack_public_path__ + "static/media/sismac.256ab526.svg";